function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { frequency, times, timeZones, timeZone } from "../../data/schedule";
import { downloadTemplate, PRODUCT_COLUMNS, PRODUCT_SPEC_URL } from "../../functions/csv-templates";

/*
 * "Pick up a file from your website" in the upload-page format (manage.jsx, non-legacy).
 * Same model as fetch.jsx ({frequency, hour, timezone, url, username, password, status}) so
 * PUT /product/schedule is unchanged; fetch.jsx stays for the legacy layout.
 */
const ZONE_WORDS = {
  "-08:00": "Pacific time",
  "-07:00": "Mountain time",
  "-06:00": "Central time",
  "-05:00": "Eastern time"
};
const hourWords = h => {
  const n = Number(h);
  return `${(n + 11) % 12 + 1}:00 ${n < 12 ? "AM" : "PM"}`;
};
export default class FetchKit extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "save", () => {
      const {
        frequency: f,
        hour,
        timezone,
        url,
        username,
        password,
        status
      } = this.state;
      this.props.onSaveFetch({
        frequency: f,
        hour,
        status,
        timezone,
        url: url.trim(),
        username,
        password
      });
    });
    _defineProperty(this, "download", url => {
      try {
        window.download(url);
      } catch (e) {
        window.open(url, "_blank");
      }
    });
    const d = props.data;
    let s = {
      frequency: "Daily",
      hour: 23,
      timezone: "-05:00",
      url: "",
      username: "",
      password: "",
      status: ""
    };
    if (d) {
      let settings = {};
      try {
        settings = JSON.parse(d.settings || "{}");
      } catch (e) {
        settings = {};
      }
      const tz = d.timezone ? timeZone(String(d.timezone)) : null;
      s = {
        frequency: d.frequency || "Daily",
        hour: d.hour != null ? Number(d.hour) : 23,
        timezone: tz && tz.value || "-05:00",
        url: settings.Url || "",
        username: settings.Username || "",
        password: settings.Password || "",
        status: d.status || ""
      };
    }
    this.state = {
      ...s,
      showLogin: !!(s.username || s.password),
      confirmDelete: false
    };
  }
  render() {
    const st = this.state;
    const exists = !!this.props.data;
    const when = `${st.frequency === "Daily" ? "Every day" : st.frequency === "Weekly" ? "Every week" : "Every month"} at ${hourWords(st.hour)} ${ZONE_WORDS[st.timezone] || ""}`.trim();
    return /*#__PURE__*/React.createElement("div", {
      className: "aup-steps"
    }, /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "aup-row"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "1 \xB7 Get your file ready"), /*#__PURE__*/React.createElement("span", {
      className: "ecc-spacer"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      onClick: () => window.open(PRODUCT_SPEC_URL, "_blank", "noopener")
    }, "What each column means"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      onClick: () => downloadTemplate("product-template.csv", PRODUCT_COLUMNS)
    }, "Download a template")), /*#__PURE__*/React.createElement("span", {
      className: "aup-hint"
    }, "Put a CSV or text file with one row per product at a web address Plunk can reach. Keep it up to date and Plunk picks up the changes.")), /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "2 \xB7 Where the file is"), /*#__PURE__*/React.createElement("label", {
      className: "aup-lab"
    }, "Web address of the file", /*#__PURE__*/React.createElement("input", {
      className: "aup-input aup-wide",
      type: "url",
      value: st.url,
      placeholder: "https://www.example.com/products.csv",
      onChange: e => this.setState({
        url: e.target.value
      })
    })), /*#__PURE__*/React.createElement("span", {
      className: "aup-hint"
    }, "Addresses starting with http, https or ftp work."), st.showLogin ? /*#__PURE__*/React.createElement("div", {
      className: "aup-two"
    }, /*#__PURE__*/React.createElement("label", {
      className: "aup-lab"
    }, "User name", /*#__PURE__*/React.createElement("input", {
      className: "aup-input",
      value: st.username,
      autoComplete: "off",
      onChange: e => this.setState({
        username: e.target.value
      })
    })), /*#__PURE__*/React.createElement("label", {
      className: "aup-lab"
    }, "Password", /*#__PURE__*/React.createElement("input", {
      className: "aup-input",
      type: "password",
      value: st.password,
      autoComplete: "new-password",
      onChange: e => this.setState({
        password: e.target.value
      })
    }))) : /*#__PURE__*/React.createElement("a", {
      className: "aup-link",
      onClick: () => this.setState({
        showLogin: true
      })
    }, "The file needs a user name and password")), /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "3 \xB7 When to pick it up"), /*#__PURE__*/React.createElement("div", {
      className: "aup-three"
    }, /*#__PURE__*/React.createElement("label", {
      className: "aup-lab"
    }, "How often", /*#__PURE__*/React.createElement("select", {
      className: "aup-select",
      value: st.frequency,
      onChange: e => this.setState({
        frequency: e.target.value
      })
    }, frequency.map(o => /*#__PURE__*/React.createElement("option", {
      key: o.value,
      value: o.value
    }, o.value === "Daily" ? "Every day" : o.value === "Weekly" ? "Every week" : "Every month")))), /*#__PURE__*/React.createElement("label", {
      className: "aup-lab"
    }, "At", /*#__PURE__*/React.createElement("select", {
      className: "aup-select",
      value: st.hour,
      onChange: e => this.setState({
        hour: Number(e.target.value)
      })
    }, times.map(o => /*#__PURE__*/React.createElement("option", {
      key: o.value,
      value: o.value
    }, hourWords(o.value))))), /*#__PURE__*/React.createElement("label", {
      className: "aup-lab"
    }, "Time zone", /*#__PURE__*/React.createElement("select", {
      className: "aup-select",
      value: st.timezone,
      onChange: e => this.setState({
        timezone: e.target.value
      })
    }, timeZones.map(o => /*#__PURE__*/React.createElement("option", {
      key: o.value,
      value: o.value
    }, ZONE_WORDS[o.value] || o.label))))), /*#__PURE__*/React.createElement("span", {
      className: "aup-hint"
    }, when, ".", st.frequency !== "Daily" ? " Weekly and monthly pickups happen on the first day of the week or month." : ""), /*#__PURE__*/React.createElement("div", {
      className: "aup-actions"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      onClick: this.save
    }, exists ? "Save changes" : "Start picking it up"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      onClick: this.props.onFetchBack
    }, "Back"), /*#__PURE__*/React.createElement("span", {
      className: "ecc-spacer"
    }), exists && this.props.onDeleteFetch ? st.confirmDelete ? /*#__PURE__*/React.createElement("span", {
      className: "aup-confirm"
    }, "Stop picking up this file?", /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base aup-danger",
      onClick: this.props.onDeleteFetch
    }, "Stop"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      onClick: () => this.setState({
        confirmDelete: false
      })
    }, "Keep")) : /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base aup-danger",
      onClick: () => this.setState({
        confirmDelete: true
      })
    }, "Stop picking it up") : null)));
  }
}